export default __webpack_public_path__ + "static/media/excavation7.ddfb5a52.jpg";